import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import ActivityCategoryTable from '@activities/components/tables/activity-category-table/activity-category-table.vue';

@Component({
  name: 'bpc-activity-categories',
  components: {
    'bpc-activity-categories-table': ActivityCategoryTable,
  },
})
export default class ActivityCategories extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
